import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import "../../css/layout.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCopy,
  faCog,
  faChartLine,
  faAddressBook,
  faCalendar,
  faCalendarCheck,
  faCaretDown,
  faCaretUp,
  faList,
} from "@fortawesome/free-solid-svg-icons";
import t3logo from "../../assets/finsi_logo.png";
import {
  MANAGER,
  PORTAL_ADMIN,
  TEAM_LEADER,
  PROJECT_ADMIN,
  PROJECT_SPONSOR,
  HR_ADMIN,
  FINANCE_APPROVER,
  EMPLOYEE,
} from "../../store/actions/users/usersActions";
import { Cache } from "aws-amplify";

class SideNavbar extends Component {
  constructor(props) {
    super(props);
    this.roleId = "";
    this.subMenuClass = "submenu-link";
  }

  componentDidMount() {
    this.displayDownCaret = "inline";

    //show reports links if on a reports page
    const pathname = this.props.location.pathname;
    if (pathname.includes("/reports")) {
      this.toggleReportsMenu();
    }

    if (pathname.includes("/settings")) {
      this.toggleSettingsMenu();
    }
  }

  displayProjectMenu = () => {
    if (
      this.roleId !== MANAGER &&
      this.roleId !== PORTAL_ADMIN &&
      this.roleId !== PROJECT_ADMIN &&
      this.roleId !== FINANCE_APPROVER &&
      this.roleId !== PROJECT_SPONSOR &&
      this.roleId !== TEAM_LEADER &&
      this.roleId !== EMPLOYEE
    ) {
      return "";
    }

    return (
      <Link
        to="#"
        onClick={(e) => {
          e.preventDefault();
          this.props.history.push("/projects");
        }}
      >
        <FontAwesomeIcon icon={faCopy} /> Projects
      </Link>
    );
  };

  toggleSettingsMenu = () => {
    document.getElementsByClassName("settings caret-up-icon")[0].style.display =
      this.displayDownCaret;
    this.displayDownCaret =
      this.displayDownCaret === "none" ? "inline" : "none";
    document.getElementsByClassName(
      "settings caret-down-icon"
    )[0].style.display = this.displayDownCaret;

    Array.from(document.getElementsByClassName("settings-sub-menus")).forEach(
      (element) => {
        element.style.display =
          element.offsetParent === null ? "block" : "none";
      }
    );
  };

  displaySettingsLink = (setting, key) => {
    return (
      <Link
        to="#"
        className={"settings-sub-menus " + this.subMenuClass}
        key={key}
        onClick={(e) => {
          e.preventDefault();
          this.props.history.push("/settings" + setting.link);
        }}
      >
        {setting.name}
      </Link>
    );
  };

  displaySettingsMenu = () => {
    let settingsLinks = [];

    if (this.roleId === PORTAL_ADMIN) {
      settingsLinks = [
        { link: "/users", name: "Users" },
        { link: "/platforms", name: "Groups" },
        { link: "/clients", name: "Clients" },
        { link: "/holidays", name: "Holidays" },
        { link: "/tasks", name: "Tasks" },
        { link: "/costcenters", name: "Cost Center" },
      ];
    } else if (this.roleId === HR_ADMIN) {
      settingsLinks = [{ link: "/users", name: "Users" }];
    } else if (this.roleId === FINANCE_APPROVER) {
      settingsLinks = [{ link: "/platforms", name: "Groups" }];
    } else if (this.roleId === PROJECT_ADMIN) {
      settingsLinks = [
        { link: "/clients", name: "Clients" },
        { link: "/holidays", name: "Holidays" },
        { link: "/tasks", name: "Tasks" },
        { link: "/costcenters", name: "Cost Center" },
      ];
    } else {
      return "";
    }

    const settingsList = settingsLinks.map((setting, key) =>
      this.displaySettingsLink(setting, key)
    );

    return (
      <>
        <Link
          to="#"
          onClick={(e) => {
            e.preventDefault();
            this.toggleSettingsMenu();
          }}
        >
          <FontAwesomeIcon icon={faCog} /> Settings{" "}
          <FontAwesomeIcon
            className="settings caret-down-icon"
            icon={faCaretDown}
          />
          <FontAwesomeIcon
            className="settings caret-up-icon"
            icon={faCaretUp}
          />
        </Link>
        {settingsList}
      </>
    );
  };

  displayApprovalsMenu = () => {
    if (this.roleId === EMPLOYEE) {
      return "";
    }

    return (
      <Link
        to="#"
        onClick={(e) => {
          e.preventDefault();
          this.props.history.push("/approvals");
        }}
      >
        <FontAwesomeIcon icon={faCalendarCheck} /> Approvals
      </Link>
    );
  };

  displayReportsLinks = (report, key) => {
    return (
      <Link
        to="#"
        className={"report-sub-menus " + this.subMenuClass}
        key={key}
        onClick={(e) => {
          e.preventDefault();
          this.props.history.push("/reports/" + report.link);
        }}
      >
        {report.name}
      </Link>
    );
  };

  toggleReportsMenu = () => {
    document.getElementsByClassName("caret-up-icon")[0].style.display =
      this.displayDownCaret;
    this.displayDownCaret =
      this.displayDownCaret === "none" ? "inline" : "none";
    document.getElementsByClassName("caret-down-icon")[0].style.display =
      this.displayDownCaret;

    Array.from(document.getElementsByClassName("report-sub-menus")).forEach(
      (element) => {
        element.style.display =
          element.offsetParent === null ? "block" : "none";
      }
    );
  };

  displayReportsMenu = () => {
    let reportLinks = [
      { link: "weekly-monthly-reports", name: "Weekly / Monthly Reports" },
    ];

    if (
      this.roleId === TEAM_LEADER ||
      this.roleId === PORTAL_ADMIN ||
      this.roleId === PROJECT_ADMIN ||
      this.roleId === HR_ADMIN
    ) {
      reportLinks = reportLinks.concat([
        { link: "missing-entries", name: "Missing Entries" },
      ]);
    }

    if (this.roleId === MANAGER) {
      reportLinks = reportLinks.concat([
        { link: "project-run-rate", name: "Project Run Rate" },
        {
          link: "project-timesheet-cumulative",
          name: "Project Timesheet Cumulative",
        },
        { link: "accomplishment-report", name: "Accomplishment Report" },
      ]);
    }

    if (this.roleId === PROJECT_SPONSOR) {
      reportLinks = reportLinks.concat([
        { link: "project-run-rate", name: "Project Run Rate" },
        { link: "profitability-per-project", name: "P&L per Project" },
      ]);
    }

    if (this.roleId === FINANCE_APPROVER) {
      reportLinks = reportLinks.concat([
        { link: "profitability-per-project", name: "P&L per Project" },
        { link: "profitability-per-client", name: "P&L per Client" },
      ]);
    }

    if (this.roleId === PORTAL_ADMIN || EMPLOYEE || TEAM_LEADER) {
      reportLinks = reportLinks.concat([
        { link: "productivity-report", name: "Productivity Report" },
      ]);
    }

    const reportsList = reportLinks.map((report, key) =>
      this.displayReportsLinks(report, key)
    );

    return (
      <>
        <Link
          to="#"
          onClick={(e) => {
            e.preventDefault();
            this.toggleReportsMenu();
          }}
        >
          <FontAwesomeIcon icon={faAddressBook} /> Reports{" "}
          <FontAwesomeIcon
            className="reports caret-down-icon"
            icon={faCaretDown}
          />
          <FontAwesomeIcon className="reports caret-up-icon" icon={faCaretUp} />
        </Link>
        {reportsList}
      </>
    );
  };

  displayTimesheetMenu = () => {
    return (
      <Link
        to="#"
        onClick={(e) => {
          e.preventDefault();
          this.props.history.push("/timesheet");
        }}
      >
        <FontAwesomeIcon icon={faCalendar} /> My Timesheet
      </Link>
    );
  };

  displayMyTaskMenu = () => {
    if (this.roleId === MANAGER || this.roleId === TEAM_LEADER) {
      return (
        <Link
          to="#"
          onClick={(e) => {
            e.preventDefault();
            this.props.history.push("/teamdailytasks");
          }}
        >
          <FontAwesomeIcon icon={faList} /> Team Daily Tasks
        </Link>
      );
    } else {
      return (
        <Link
          to="#"
          onClick={(e) => {
            e.preventDefault();
            this.props.history.push("/dailytasks/list");
          }}
        >
          <FontAwesomeIcon icon={faList} /> My Tasks
        </Link>
      );
    }
  };

  displayDashboard = () => {
    return (
      <Link
        to="#"
        onClick={(e) => {
          e.preventDefault();
          this.props.history.push("/dashboard");
        }}
      >
        <FontAwesomeIcon icon={faChartLine} /> Dashboard
      </Link>
    );
  };

  render() {
    this.roleId = Cache.getItem("roleId");
    return (
      <React.Fragment>
        <div className="sidenav">
          <img
            className="company-logo"
            src={t3logo}
            alt="finsi-logo"
            width="100%"
            height="auto"
          />
          {this.displayDashboard()}
          {this.displayTimesheetMenu()}
          {this.displayProjectMenu()}
          {this.displayMyTaskMenu()}
          {this.displayApprovalsMenu()}
          {this.displayReportsMenu()}
          {this.displaySettingsMenu()}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
});

export default withRouter(connect(mapStateToProps)(SideNavbar));
